export default __webpack_public_path__ + "static/redStamp-ced4b5dd516b55ccb674f62a23fae052.png";